// eslint-disable-next-line import/no-extraneous-dependencies, no-unused-vars
import React from 'react';
import { renderToString } from 'react-dom/server';
import { Helmet } from 'react-helmet';

import disableReactDevTools from 'Utils/disableReactDevTools';
import AppProvidersWrapper from 'Providers/app';
import App from 'Containers/App';

export default (initialProps, context) => {
  if (context && context.serverSide) {
    const renderedHtml = {
      componentHtml: renderToString(
        <AppProvidersWrapper initialProps={ initialProps } context={ context }>
          <App initialProps={ initialProps } />
        </AppProvidersWrapper>
      ),
      title: Helmet.renderStatic().title.toString()
    };
    return { renderedHtml };
  }

  return props => (
    <AppProvidersWrapper initialProps={ props } context={ context }>
      <App initialProps={ props } />
    </AppProvidersWrapper>
  );
};

if (process.env.NODE_ENV === 'production') disableReactDevTools();

if (module.hot) {
  module.hot.accept();
}
